import { putApi } from "./api_instance";

export const ListPopUpPostApi = async (projectId, formData, dispatch) => {
  try {
    return await putApi({
      apiUrl: "/projects/api/holdings/listProject",
      sendToken: true,
      dispatch,
      data: {
        projectId,
        ...formData,
      },
    });
  } catch (error) {
    throw error;
  }
};
